import { ITranslations } from 'types/common';
import { CreatedBySelectTransFields } from './types';
import en from 'translations/en/createdBySelect.json';
import pl from 'translations/pl/createdBySelect.json';
import sl from 'translations/sl/createdBySelect.json';

export const createdBySelectTranslations: ITranslations<CreatedBySelectTransFields> = {
  name: 'createdBySelect',
  en,
  pl,
  sl,
};
